import { Component, OnInit, ViewChild } from "@angular/core";
import { DatatableComponent } from "@swimlane/ngx-datatable";
import { ActivatedRoute} from '@angular/router';
import { DatePipe } from '@angular/common';
import { NavigationExtras } from '@angular/router';
import { AlertComponent } from 'ngx-bootstrap/alert/alert.component';
import { ChecklistFacade } from "../../../common/facade/ChecklistFacade";
import { ExcelUtility } from '../../../common/util/ExcelUtility';

@Component({
    selector: "app-reportstoreinventory",
    templateUrl: "./reportstoreinventory.component.html"
})

export class ReportStoreInventoryComponent
    implements OnInit {

    //Properties and Attributes
    @ViewChild('tableActivities') tableActivities: DatatableComponent;
    TitleActivity: string = "";
    Loading = false;
    MessageLoader = '';
    message = '';
    modalTitle = '';
    rows: any = [];
    columns: any = []
    public rptActivExtras: NavigationExtras;
    public rptActivPath ='views/task/report';
    private _filteredData = [];
    private _taskId: string ="";
    private _requiredDate: string ="";

    //alert
    alerts: any[] = [];

    //Constructor
    constructor(
        private _facade: ChecklistFacade,
        private _route: ActivatedRoute,
        private _datePipe: DatePipe,
        private _excel: ExcelUtility,
    ) {}

    //EventHandlers
    ngOnInit() {
        const navigation = this._route.queryParams.subscribe(params => {
            this._taskId = params["pCd"];
            this._requiredDate = params["pRqrd"];
          });

        this.Loading = true;
        this.MessageLoader = "Cargando Información";
  
        this._facade.GetInstructionInventory(parseInt(this._taskId)).subscribe(result => {
            if(result.completed)
            {
                var reqDate = new Date(Number(this._requiredDate.substr(0, 4)),
                                   Number(this._requiredDate.substr(4, 2))-1,
                                   Number(this._requiredDate.substr(6, 2)))
                                               
                this.TitleActivity = result.message + ' ' + this._datePipe.transform(reqDate, "dd/MM/yyyy");

                const data: any = [];

                result.data.forEach(row => {
                    const info = <any>{}
                    info.Grupo = row.checklistSections[0].title
                    info.Producto = row.title
                    row.activityStoreInstructions.forEach(instruction => {
                        info['T-' + instruction.storeId.toString()] = instruction.answerText
                    });
                    data.push(info);
                });

                this.rows = data;
                this._filteredData = this.rows;

                let columns = Object.keys(this.rows[0]).map((key) => {
                    return {
                      'name': key,
                      'prop': key
                    }
                  });
                this.columns = columns;
            }
            this.Loading = false;
        }, error => 
        {
            this.addAlert('<strong>'+error+'</strong>','danger')
            this.Loading = false;
        });
    }

    updateFilter(event) {
        let val = event.target.value.toLowerCase();

        let keys = Object.keys(this._filteredData[0]);
        this.rows = this._filteredData.filter(function (item) {
            for (let i = 0; i < keys.length; i++) {

                if (item[keys[i]] != null &&
                    (item[keys[i]].toString().toLowerCase().indexOf(val) !== -1 || !val)) 
                {
                    return true;
                }
            }
        });

        this.tableActivities.offset = 0;
    }

    goBack()
    {
        window.history.back();
    }

    // añadir alert
    addAlert(message: String, type: String): void {
        this.alerts = []
        this.alerts.push({
            type: type,
            msg: message
        });
    }

    // cerrar alert
    onClosed(dismissedAlert: AlertComponent): void 
    {
        this.alerts = this.alerts.filter(alert => alert !== dismissedAlert);
    }

    downloadLayout() {
        if (this.rows.length > 0) {
            this._excel.exportAsExcelFile(this.rows, this.TitleActivity);
        } else {
            this.addAlert('Deber seleccionar un tipo de actividad primero.', 'danger');
        }
    }
}